function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { splitOnQuery, decode } from './utils';

/**
* Parses query parameters from a string, returning the query parameters as an object.
* @param {string} [strToParse=''] - The string from which to parse query parameters
* @param {boolean} [favorQuery=true] - Whether or not to treat the full string to parse as query parameters when it doesn't have "?" in it
* @returns {UrlParams} Parsed query parameters
*/
var parseQuery = function parseQuery() {
  var strToParse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var favorQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  // Ensure that all we parse is a query string
  var _splitOnQuery = splitOnQuery(strToParse, favorQuery !== false),
      _splitOnQuery$querySt = _splitOnQuery.queryString,
      queryString = _splitOnQuery$querySt === void 0 ? '' : _splitOnQuery$querySt;

  return queryString.split('&').reduce(function (prevUrlParams, serializedUrlParamPair) {
    var urlParams = prevUrlParams;

    var _serializedUrlParamPa = serializedUrlParamPair.split('='),
        _serializedUrlParamPa2 = _slicedToArray(_serializedUrlParamPa, 2),
        urlParamNameEncoded = _serializedUrlParamPa2[0],
        urlParamValueEncoded = _serializedUrlParamPa2[1];

    if (urlParamNameEncoded) {
      urlParams[decode(urlParamNameEncoded)] = decode(urlParamValueEncoded);
    }

    return urlParams;
  }, {});
};

export default parseQuery;